import { URL } from "../../api/Api";
import { catchError, PUT } from "../axios/Axios";

export const GetStartedCall = async (id) => {
  try {
    const response = await PUT(
      `${URL}/customers/onboarding/completion/${id}`,
      "",
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};
